import React from 'react';
import MarkdownRender from '@/components/text-editors/MarkdownRender';
import { camelConverter } from '../helper';

const FormLabel = ({ field }) => (
  <MarkdownRender className="aridhia-form-label" id={camelConverter(field.name, '_')} value={field.label} />
);

export default FormLabel;
